<template>
  <div>
    <h1 class="text-center mb-3">Grunnleggende info</h1>
    <PersonList
      title="Selger(e) / Eier(e)"
      v-model="stepValues.sellers"
      dialogText="<p>
            Selgere av boligen
          </p>"
    ></PersonList>

    <v-card class="mb-4 mt-4">
      <v-toolbar color="accent" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-home</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Boliginformasjon</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm6 class="pr-sm-3">
            <v-select
              label="Boligtype"
              v-model="stepValues.houseType"
              :items="houseTypeList"
              :append-outer-icon="stepValues.houseType.icon"
              item-text="name"
              return-object
              @change="updateFields"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 class="pl-sm-3">
            <v-select
              label="Eierform"
              v-model="stepValues.ownerType"
              :items="ownerTypeList"
              :append-outer-icon="stepValues.ownerType.icon"
              item-text="name"
              return-object
              @change="updateFields"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-checkbox
              v-model="stepValues.hasRental"
              label="Boligen har utleiedel"
              color="primary"
              hide-details
              @change="updateFields"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card class="mt-4 mb-4">
      <v-toolbar color="accent" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-comment-text</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Beskrivelse av boligen</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-textarea
            solo
            box
            label="Beskriv boligen"
            v-model="stepValues.description"
            @input="updateFields"
          ></v-textarea>
        </v-flex>
      </v-card-text>
    </v-card>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import PersonList from "../../form/PersonList.vue";
import HOUSETYPES from "../../../models/houseTypes";
import HouseTypeFactory from "../../../models/houseTypeFactory";
import OWNERTYPES from "../../../models/ownerTypes";
import OwnerTypeFactory from "../../../models/ownerTypeFactory";
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      houseTypes: HOUSETYPES,
      ownerTypes: OWNERTYPES
    };
  },
  beforeMount: function() {
    if (!this.stepValues.houseType) {
      this.stepValues.houseType = HouseTypeFactory.createInstance("House")
    }
    if (!this.stepValues.ownerType) {
      this.stepValues.ownerType = OwnerTypeFactory.createInstance("Freehold")
    }
  },
  mounted: function() {},
  components: { PersonList },
  computed: {
    houseTypeList: {
      get() {
        let arr = [];
        for (var propertyName in this.houseTypes) {
          let hType = HouseTypeFactory.createInstance(propertyName);
          arr.push(hType);
        }
        return arr;
      }
    },
    ownerTypeList: {
      get() {
        let arr = [];
        for (var propertyName in this.ownerTypes) {
          let oType = OwnerTypeFactory.createInstance(propertyName);
          arr.push(oType);
        }
        return arr;
      }
    }
  }
};
</script>

<style>
.v-input--selection-controls.v-input .v-label {
  top: 4px;
}
</style>